// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1bzT1","list":"PatternAutocomplete_list__3pYXa"};